import styles from './SectionNumber.module.css';

interface Props {
  number: string;
  label: string;
  count?: number;
  countLabel?: string;
  sublabel?: string;
  collapsed?: boolean;
  onToggle?: () => void;
}

export function SectionNumber({
  number,
  label,
  count,
  countLabel = 'optys',
  sublabel,
  collapsed,
  onToggle,
}: Props) {
  const clickable = onToggle !== undefined;
  return (
    <div
      className={`${styles.root} ${clickable ? styles.clickable : ''}`}
      onClick={clickable ? onToggle : undefined}
      role={clickable ? 'button' : undefined}
      aria-expanded={clickable ? !collapsed : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle?.();
        }
      } : undefined}
    >
      {clickable && (
        <span className={styles.chevron} aria-hidden="true">
          {collapsed ? '▸' : '▾'}
        </span>
      )}
      <span className={styles.number}>{number}</span>
      <h2 className={styles.label}>{label}</h2>
      {count !== undefined && (
        <span className={styles.count}>
          {count} {countLabel}{sublabel ? ` · ${sublabel}` : ''}
        </span>
      )}
    </div>
  );
}
